import { Radio } from '@material-ui/core';
import React from 'react';
import styles from './StepSelector.module.css';
import classNames from 'classnames';
/**
 * @deprecated Please use the step selector in the components director
 */
export var StepSelector = function (props) {
    var _a;
    var containerClasses = classNames(styles.container, (_a = {},
        _a[styles.active] = props.active,
        _a));
    return (React.createElement("div", { className: containerClasses, onClick: function () { return props.onClick(props.value); } },
        React.createElement("div", { className: styles.icon },
            React.createElement(Radio, { checked: props.active, value: props.value, "data-test-id": props.testId })),
        React.createElement("div", { className: styles.information },
            React.createElement("div", { className: styles.title }, props.text),
            React.createElement("div", { className: styles.info }, props.info))));
};
